import Vue from 'vue';
import axios from 'axios';
window._ = require('lodash');
window.Vue = Vue;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('admin-lte');
    require('icheck');
    require('./select2-4.0.18');
    require('daterangepicker');
} catch (e) {}

window.moment = require('moment');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

Vue.prototype.trans = (string, args) => {
    let value = _.get(window.trans, string);

    _.eachRight(args, (paramVal, paramKey) => {
        value = _.replace(value, `:${paramKey}`, paramVal);
    });
    return value;
};

Vue.mixin({
    data: function () {
        return {
            globalErrors: {},
        };
    },

    methods: {
        onError: function (err) {
            var vm = this;
            if (err.response.status === 422) {
                vm.globalErrors = {};

                for (var key in err.response.data.errors) {
                    if (!Object.prototype.hasOwnProperty.call(err.response.data.errors, key)) {
                        continue;
                    }

                    err.response.data.errors[key].forEach(function (err) {
                        vm.$set(vm.globalErrors, key, err);
                    });
                }
            }
        },

        cleanErrors: function () {
            this.$set(this, 'globalErrors', {});
        },
    },
});
